// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--2Onlx","title":"card-module--title--27nCp","intro":"card-module--intro--2B1E2","cta":"card-module--cta--1pLFH"};